import React from 'react';

/**
 * Admin data-ops toolbar — Seed Validation + Mailchimp sync buttons, with inline action feedback.
 */
export default function AdminDataOpsToolbar({ actionRunning, actionResult, runAction }) {
  return (
    <div className="flex flex-wrap gap-2 mb-4" data-testid="admin-dataops">
      <button
        onClick={() => runAction('Seed validation data (63 barcodes)', '/api/admin/seed-validation')}
        disabled={!!actionRunning}
        className="px-3 py-2 text-xs font-semibold rounded bg-[#00D26A]/10 border border-[#00D26A]/30 text-[#00D26A] hover:bg-[#00D26A]/20 disabled:opacity-40"
        data-testid="admin-seed-btn"
      >
        {actionRunning === 'Seed validation data (63 barcodes)' ? 'Seeding…' : '↓ Seed Validation (63 barcodes)'}
      </button>
      <button
        onClick={() => runAction('Sync Mailchimp waitlist to DB', '/api/admin/sync-mailchimp')}
        disabled={!!actionRunning}
        className="px-3 py-2 text-xs font-semibold rounded bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] hover:bg-[#FFD700]/20 disabled:opacity-40"
        data-testid="admin-sync-mailchimp-btn"
      >
        {actionRunning === 'Sync Mailchimp waitlist to DB' ? 'Syncing…' : '⇆ Sync Mailchimp → DB'}
      </button>
      {actionResult && (
        <div
          className={`px-3 py-2 text-xs rounded ${actionResult.ok ? 'bg-[#00D26A]/10 text-[#00D26A]' : 'bg-red-900/30 text-red-300'} flex-1 min-w-[200px]`}
          data-testid="admin-action-result"
        >
          <strong>{actionResult.label}:</strong>{' '}
          {actionResult.ok
            ? Object.entries(actionResult.data)
                .filter(([k]) => k !== 'success')
                .map(([k, v]) => `${k}=${v}`).join('  ·  ')
            : `❌ ${actionResult.error}`}
        </div>
      )}
    </div>
  );
}
